exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TV_page_2SwU {}\n\n.TV_noTV_k9QK {\n  padding: 10px;\n\n  text-align: center;\n}\n\n.TV_price_3usl {\n  font-size: 21px;\n\n  color: #282828;\n}\n\n.TV_connectLink_c7Je {\n  margin-bottom: 10px;\n}\n\n.TV_buttonContainer_1Qum:not(:first-child) {\n  margin-top: 10px;\n  padding-top: 20px;\n  border-top: 1px solid #d4d4d4;\n}\n\n.TV_error_2Asx {\n  max-width: none;\n\n  text-align: left;\n}\n\n.TV_newDevicesBanner_TP6p {\n  margin-top: 20px;\n  padding: 30px 0 10px;\n\n  text-align: center;\n\n  border-top: 1px solid #d4d4d4\n}\n\n.TV_newDevicesBanner_TP6p:first-child {\n  margin-top: 0;\n  padding-top: 10px;\n  border-top: none;\n}\n\n.TV_newDevicesBannerText_rW3W,\n.TV_newDevicesBannerButtons_1TF_ {\n  margin-top: 20px;\n}\n\n.TV_appButton_2JQB {\n  margin: 0 10px;\n}\n\n.TV_presetLink_2SHw {\n  padding: 10px 0;\n\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"page": "TV_page_2SwU",
	"noTV": "TV_noTV_k9QK",
	"price": "TV_price_3usl",
	"connectLink": "TV_connectLink_c7Je",
	"buttonContainer": "TV_buttonContainer_1Qum",
	"error": "TV_error_2Asx",
	"newDevicesBanner": "TV_newDevicesBanner_TP6p",
	"newDevicesBannerText": "TV_newDevicesBannerText_rW3W",
	"newDevicesBannerButtons": "TV_newDevicesBannerButtons_1TF_",
	"appButton": "TV_appButton_2JQB",
	"presetLink": "TV_presetLink_2SHw"
};